import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import PageSkeleton from '../../components/PageSkeleton';
import LoadingPageError from '../../components/LoadingPageError';
const PublicVideoPageLoadable = Loadable({
  loader: () => import( /* webpackChunkName: "PublicVideoPage" */'../PublicVideoPage'),
  LoadingComponent: PageSkeleton,
  ErrorComponent: LoadingPageError
});
export default PublicVideoPageLoadable;